namespace $.$$ {
	export class $shm_projects_module_card extends $.$shm_projects_module_card {
		module() {
			return this.$.$shm_projects_data.records().flatMap( project => project.modules ?? [] ).find( module => module.id === this.module_id() )
		}
		description() { return this.module()?.description ?? '' }
		module_arg() {
			return { section: 'projects', project: this.project_id(), project_tab: 'modules', project_module: this.module_id(), projects_map: null }
		}
	}
}
